import { useParams } from 'react-router-dom'
import _ from 'underscore'
import styled from 'styled-components'

import SiteMessage from 'models/SiteMessage'

import NotFound from 'pages/NotFound'
import SiteMessageForm from 'pages/shared/SiteMessageForm'

import useSiteMessages from 'hooks/useSiteMessages'
import { useStoreContext } from 'hooks/StoreContext'

import { PageHeader, PageTitle, LoadingSinglePanePage, SinglePanePage, screenSize } from 'styles/shared'

const EditSiteMessage = () => {
  useSiteMessages({ listForAllBrands: true, listForAllTiers: true })

  const { siteMessages, areSiteMessagesLoaded } = useStoreContext()
  const { id } = useParams()

  if (!areSiteMessagesLoaded) {
    return <LoadingSinglePanePage />
  }

  const siteMessage = _.find(siteMessages, (siteMessage) => siteMessage.id.toString() === id)

  if (!siteMessage) {
    return (
      <SinglePanePage>
        <NotFound />
      </SinglePanePage>
    )
  }

  return (
    <>
      <PageHeader>
        <S.PageTitle>Edit Site Message</S.PageTitle>
      </PageHeader>
      <S.SinglePanePage>
        <SiteMessageForm
          validatedSaveType="update"
          siteMessage={new SiteMessage(siteMessage)}
        />
      </S.SinglePanePage>
    </>
  )
}

export default EditSiteMessage

const S = {
  SinglePanePage: styled(SinglePanePage)`
    @media ${screenSize.small} {
      margin-top: 0;
    }
  `,
  PageTitle: styled(PageTitle)`
    @media ${screenSize.small} {
      display: block;
    }
  `
}
